var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "753827C3-0ACF-4586-B873-78E83AFF1CA2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Users",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "usersContactsTabAddExistingUser",
    transform: "translate(-1107.000000, -272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modalAddContact",
    transform: "translate(499.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fields_&_Inputs/Labeled/Small/Right_Icon",
    transform: "translate(135.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Close",
    transform: "translate(473.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "24pt_Bounding_Box",
    opacity: 0,
    fillRule: "nonzero",
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94,8 L11.8066667,5.14 L11.8066667,5.13999995 C12.0680814,4.87858529 12.0680814,4.45474662 11.8066666,4.19333329 C11.545252,3.93191862 11.1214133,3.93191862 10.86,4.19333338 L7.99999995,7.06000005 L5.13999995,4.19333338 L5.14,4.19333343 C4.87858533,3.93191876 4.45474667,3.93191876 4.19333333,4.19333333 C3.93191867,4.454748 3.93191867,4.87858667 4.19333324,5.14 C4.19333324,5.14 4.19333324,5.14 4.19333324,5.14 L7.05999991,8 L4.19333324,10.86 L4.19333326,10.86 C3.93191859,11.11928 3.93018792,11.5413867 4.18946768,11.8028 C4.1907509,11.8040938 4.19203943,11.8053823 4.19333322,11.8066655 L4.1933332,11.8066655 C4.4526132,12.0680802 4.87471987,12.0698108 5.1361332,11.8105311 C5.137427,11.8092479 5.13871552,11.8079594 5.13999875,11.8066656 L7.99999875,8.93999889 L10.8599987,11.8066656 L10.8599987,11.8066655 C11.1192787,12.0680802 11.5413854,12.0698109 11.8027987,11.8105311 C11.8040925,11.8092479 11.805381,11.8079594 11.8066643,11.8066656 L11.8066643,11.8066656 C12.068079,11.5473856 12.0698096,11.1252789 11.8105298,10.8638656 C11.8092466,10.8625718 11.807958,10.8612832 11.8066642,10.86 L8.94,8 Z",
    id: "Fill"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8c93f029fb1a7a13f21819cf3d75ad34.svg";
export { ForwardRef as ReactComponent };